import { createAction, props } from '@ngrx/store';
import { SaveContactPayload, SaveContactResponse } from '../../model/save-contact.model';
import AppError from 'src/app/model/app-error';

export enum SaveContactActions {
  SaveContactReset = '[Save Contact] Reset',
  SaveContactStart = '[Save Contact] Start',
  SaveContactSuccess = '[Save Contact] Success',
  SaveContactError = '[Save Contact] Error',
}

const reset = createAction(SaveContactActions.SaveContactReset);
const start = createAction(SaveContactActions.SaveContactStart, props<{ payload: SaveContactPayload }>());
const success = createAction(SaveContactActions.SaveContactSuccess, props<{ success: SaveContactResponse }>());
const error = createAction(SaveContactActions.SaveContactError, props<{ error: AppError | null }>());

const processActions = {
  reset,
  start,
  success,
  error,
};

export default processActions;
